import { API_JAVA_CERT_BLOQ,  API_JAVA_AUTH, API_JAVA_VERIFICA_LCR } from '../app.api';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MessageService } from './message.service';
import { HttpUtilService } from './http-util.service';
import { Router } from '@angular/router';
import Utils from '../utils/utils';
import DadosCertificadoModel from '../model/dados-certificado.model';
import{ GlobalCripto } from './../global/global-constants';
import { CertValidator } from './certvalidator.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  constructor(
   private http: HttpClient,
    private messageService: MessageService,
    private httpUtilService: HttpUtilService,
    private zone: NgZone,
    private router: Router) { CertValidator }

  private sign: any;
  private messageError: [number, string];
  private messageSucess: [number, string];
  private listaServicos: any;
  private certificadoBloqueado: boolean;
  private certificadoValido: boolean;
  private certificadoAutorizado = false;
  private outorgado;
  private certificateFromServlet;


  OnInit() {
    this.messageService.currentErrorMessage.subscribe(messageError => {
      if (messageError) { this.messageError = [messageError[0], messageError[1]]; }
    });
    this.messageService.currentSucessMessage.subscribe(messageSucess => {
      if (messageSucess) { this.messageSucess = [messageSucess[0], messageSucess[1]]; }
    });
   

   if (!GlobalCripto.clientAPI) {
    console.log(' ClientAPI não foi instanciado...')
    }

  }

  /**
   * Chamada GET a API que fornece o TOKEN válido.
   * @returns Promise<string> token
   */
  async obterToken(): Promise<string> {
      return this.httpUtilService.get(API_JAVA_AUTH)
        .toPromise()
        .then(resp => resp['data']['token'])
        .catch(err => {
          console.error('Erro em chamada GET por TOKEN !', err);
          this.messageService.changeErrorMessage(err.name === 'HttpErrorResponse' ? 404 : err.status, 'Sistema indisponível no momento, favor tentar mais tarde. (A001)');
          this.router.navigate(['/acesso-negado']);
        });
  }

  /**
   * Verifica se certificado é permitido e obtém token automaticamente
   * @param index 
   * @returns Observable com status da autenticação
   */
  certificadoPermitido(index): any {
    return this.httpUtilService.get(API_JAVA_AUTH)
    .subscribe(
      data  => {
      sessionStorage['token'] = data['data']['token'];
      console.log('Token obtido e armazenado no sessionStorage');
      return true;
      },
      err => {
        console.error('Erro no envio', err);
        if (index !== null) {
          this.messageService.changeErrorMessage(404, 'Sistema indisponível no momento, favor tentar mais tarde. (A001)');
        }
        this.router.navigate(['/acesso-negado']);
        return false;
      }
    );
  }

  /**
   * Transforma em DadosCertificadoModel por atob(token).
   * @returns Promise<DadosCertificadoModel> dadosCertificado
   */
  async obterCertificadoPorToken(): Promise<DadosCertificadoModel> {
    return new Promise<DadosCertificadoModel>(
      resolve => {
        const token = sessionStorage['token'];
        const r :DadosCertificadoModel = JSON.parse(atob(token.split('.')[1])).sub;
        resolve(r);
      }
    );
     
  }

  /**
   * Consulta base de Certificados bloqueados pelo Gestor.
   * @param certificado 
   * @returns Promise<boolean> isCertificadoBloqueadoCPF
   */
  async validaBloqueioPorCPFResponsavel(certificado :DadosCertificadoModel): Promise<boolean> {

    let certificadoBloqueado: boolean;
    //Verifica se o CPF RESPONSAVEL está bloqueado.
    const cpf = '3' + Utils.inscricaoformatada(certificado.cpfResponsavel,14);
     await this.isCertificadoBloqueado(cpf, null).then(bloq => {
      certificadoBloqueado = bloq;
    });
  
    return certificadoBloqueado;
  }

  /**
   * 
   */
  public async validaCertificado(certificado: DadosCertificadoModel): Promise<boolean> {

    let certificadoValido: boolean = true;
     
    //Verifica bloqueio CPF Responsavel
   await this.validaBloqueioPorCPFResponsavel(certificado).then(result => {
      if(!result)
        certificadoValido = result;
    }).catch(err => {
      certificadoValido = false;
    });

    return certificadoValido;
  }

  public getNomeEntidadeCert(certificado): string {
    const nomeEntidadeCert: string = certificado !== undefined ? certificado.issuer.name.split(',')[0].split('=')[1]:undefined;
    return nomeEntidadeCert;
  }

  public getOrgaoEmissor(certificado): string {
    const oEmissor: string = certificado !== undefined ? certificado.issuer.name.split(',')[2].split('=')[1]:undefined;
    return oEmissor;
  }

  public trataMessageToken(){
    this.messageService.changeErrorMessage( 999, 'Não é possível realizar a renovação para certificado token conectividade.');
  }

  public trataRegistroInvalido(situacao: number) {
    const index = 0;
    switch (situacao) {
      case 0:
        this.messageService.changeErrorMessage( situacao, 'Certificado Não Registrado !');
        break;
      case 1:
        this.messageService.changeErrorMessage(situacao, 'Pré–registro já efetuado.');
        break;
      case 2:
        this.messageService.changeErrorMessage(situacao, 'Certificado já Autorizado !');
        break;
      case 3:
        this.messageService.changeErrorMessage(situacao,'Identificamos que seu certificado digital/token conectividade encontra-se não autorizado.');
        break;
      case 4:
        this.messageService.changeErrorMessage(situacao, 'Identificamos que seu certificado digital/token conectividade encontra-se revogado.');
        break;
      case 5:
        this.messageService.changeErrorMessage(situacao, 'Não é possível realizar o registro. Acusamos o suspensão do registro. Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO');
        break;
      // case 6:
      //   this.messageService.changeErrorMessage(index, 'Contrato renovado !');
      //   break;   
      case 7:
        this.messageService.changeErrorMessage(situacao, 'Usuário Revogou !');
        break;
      default:
        this.messageService.changeErrorMessage(situacao, 'Certificado inválido !');
    }
  }
 

  filterCertificado(index, certificados, certificadoServlet) {
    const cert = certificados.filter((cer) => {
      return cer.serial === certificadoServlet.codSerialHexaInvert;
    });
    this.messageService.changeFileProgress(index, 40);
    return cert[0];
  }


/**
 * Chamada POST ao serviço 'cns-node/api/certificado/bloqueio/'
 * @param inscricaoCertificado 
 * @param index 
 * @returns boolean isCertificadoBloqueado
 */
public async isCertificadoBloqueado(inscricaoCertificado: string, index): Promise<any> {
  const body = { inscricao: inscricaoCertificado }; 

  return false; 
  /*this.http.post(
      `${API_JAVA_CERT_BLOQ}`, 
      body,
      this.httpUtilService.headers() 
    ).toPromise()
    .then(response => {

        this.certificadoBloqueado = response['data']['outQtLin'].toString() === '0' ? false : true;
     
        if (this.certificadoBloqueado) {
        this.messageService.changeErrorMessage(index, 'Não é possível realizar o registro. Acusamos o BLOQUEIO da inscrição CNPJ/ CEI e/ou CPF no Conectividade Social. Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO');
        this.router.navigate(['/acesso-negado']);
        }
      return this.certificadoBloqueado;
    })
    .catch(err => {
      console.error('Erro', err);
      const msg = Utils.trataErro(err.status);
      this.messageService.changeErrorMessage(index, msg);
      this.router.navigate(['/acesso-negado']);
      return this.certificadoBloqueado = true;
    });*/
}



  obterDadosCertificadoServlet() {
    this.certificateFromServlet = this.httpUtilService.obterDadosCertificado();
    return this.certificateFromServlet;
  }

  async obterDadosCertificadoServletPromisse(): Promise<any> {
    return this.obterDadosCertificadoServlet();
  }
 
  async assinarCriptoCns(certificadoServlet,  termo, attach) {
          
    try {
    //lista dos certificados do browser   krypton
    let certificados =  await GlobalCripto.clientAPI.sign.enumerateCerts(); 
     
    //valida é obtem o certificado para assinar.
    const certificado = await this.filterCertificadoCripto(0,certificados, certificadoServlet);

    if(certificado === undefined){
      console.log('Certificado da Sessão não encontrado na lista de certificados do browser');
		  return '';
    }

    //XAPIRIPE assinar
    const assinado = await GlobalCripto.clientAPI.sign.sign({ certificate: certificado, toBeSigned: termo, attach })
  
    return assinado;

    }
	  catch (e) {
		  console.log('erro: ' + e.message);
		  return '';
	  }
  }

  async filterCertificadoCripto(index, certificados, certificadoServlet) {

      let cert = [];
      let matcher = new CertValidator(certificadoServlet.issuer.name, certificadoServlet.codSerialHexaInvert);
	    
	      //'Teste de comparação de issuer e serial...'
        certificados.forEach(item => {
          //retirar o ternario quando for ajustado o componente do criptoCns para retornar o issuer igual ao Kriptonita
          //Manter o matcher.match
		      let match = (GlobalCripto.apiAtiva !==  'Kryptonite') ?
              ((item.issuer === matcher.getFieldFromDN('CN')) && (item.serial.toUpperCase() === certificadoServlet.codSerialHexaInvert))
              : matcher.match(item.issuer, item.serial);

              if(match === true){
                cert.push(item);
              };
       
	      });
	  
        return cert[0]; 

  }

  filterCertificadoCriptoKry(index, certificados, certificadoServlet) {
    //nome da autoridade certificado logado
    const autoridadeCertificada =  this.getNomeAutoridadeCertificada(certificadoServlet);
    
    const cert = certificados.filter((cer) => {   
      let issuer = cer.issuer ;
      return  ( cer.serial.toUpperCase()  === certificadoServlet.codSerialHexaInvert.toUpperCase() )  &&
      ( issuer  === autoridadeCertificada)
    });
    this.messageService.changeFileProgress(index, 40);
    return cert[0];
  }

  /*
  //Pegar nome do autoridade certificado listado no browser qdo for kry
  */
 getNomeAutoridadeCertificadaKry(response) {
  const cn = 'CN=';
  const pos = response.toString().indexOf(cn);
  const dadosIssuer = response.toString().split(',');
  const certificadoCn = (pos >= 0) ?  dadosIssuer[3].toString().substr(4) : dadosIssuer[3];
  return certificadoCn;
}

/*
  //Pegar nome do autoridade certificado do certificado logado
  */
 getNomeAutoridadeCertificada(response) {
  const cn = 'CN=';
  const pos = response.issuer.name.toString().indexOf(cn);
  const dadosIssuer = response.issuer.name.toString().split(',');
  const certificadoCn = (pos === 0) ?  dadosIssuer[0].toString().substr(pos+3) : dadosIssuer[0];
  return certificadoCn;
}

  /**
   * Consulta, por Inscrição, base de Certificados bloqueados pelo Gestor.
   * @param certificado 
   * @returns Promise<boolean> isCertificadoBloqueadoInscricao
   */
  async validaBloqueioPorInscricao(certificado: DadosCertificadoModel): Promise<boolean> {

    let certificadoBloqueado: boolean;

    const cnpj: string = certificado.inscricao + '';
    await this.isCertificadoBloqueado(cnpj, null).then(bloq => {
      certificadoBloqueado = bloq;
    });

    return certificadoBloqueado;
  }

  /**
   * Verifica na base CNS se o Certificado esta bloqueado por Inscricao ou CPF Responsavel.
   * @param dadosCertificado 
   * @returns boolean isCertificadoBloqueado
   */
  public async verificarBloqueioCertificado(dadosCertificado: DadosCertificadoModel): Promise<boolean> {

    const bloqCPF = await this.validaBloqueioPorCPFResponsavel(dadosCertificado);
    if (bloqCPF) {
      this.messageService.changeErrorMessage(0, 'CPF Responsável do Certificado está bloqueado.');
      this.router.navigate(['/acesso-negado']);
      return new Promise<boolean>(r => r(bloqCPF));
    }

    if ("3" !== dadosCertificado.tpInscricao + '') {
      const bloqInscr: boolean = await this.validaBloqueioPorInscricao(dadosCertificado);
      if (bloqInscr) {
        this.messageService.changeErrorMessage(0, 'Certificado bloqueado por inscrição.');
        this.router.navigate(['/acesso-negado']);
      }
      return new Promise<boolean>(r => r(bloqInscr));
    }

    return new Promise<boolean>(r => r(false));
  }

  /**
   * Verifica na base CNS se o Certificado esta bloqueado por LCR.
   * @param dadosCertificado 
   * @returns Observable<any>
   */
  public verificarBloqueioLCR(dadosCertificado: DadosCertificadoModel): Observable<any> {
    return this.httpUtilService.post(`${API_JAVA_VERIFICA_LCR}`, JSON.stringify(""));
  }

}
